export default {
  labels: {
    today: 'Hoje',
    pickup_time: 'Hora de recolha',
    delivery_time: 'Hora de entrega',
  },
};
